import {Component, Input, OnInit} from '@angular/core';
import {WordService} from "../../../services/vocab/word.service";
import {SysGrammarService} from "../../../services/grammar/sys-grammar.service";
import {FuncGrammarService} from "../../../services/grammar/func-grammar.service";
import {NotificationService} from "../../../services/common/notification.service";
import {SharedService} from "../../../services/common/shared.service";
import {TextTypeService} from "../../../services/text/text-type.service";
import {VerbalActionEntryService} from "../../../services/verbal-action/verbal-action-entry.service";
import {GlobalCanDoStatementService} from "../../../services/can-do-statement/global-can-do-statement.service";
import {DetailedCanDoStatementService} from "../../../services/can-do-statement/detailed-can-do-statement.service";
import {finalize} from "rxjs";

@Component({
    selector: 'app-entry-details',
    templateUrl: './entry-details.component.html',
    styleUrls: ['./entry-details.component.scss'],
    standalone: false
})
export class EntryDetailsComponent implements OnInit {
  @Input() id: number;
  @Input() service: WordService | SysGrammarService | FuncGrammarService | TextTypeService | VerbalActionEntryService
    | GlobalCanDoStatementService | DetailedCanDoStatementService;
  /* things to improve if wanted:
     way of displaying the niveau
     Themenbaum clickable das es sich automatisch öffnet
   */

  error = false;

  loading: boolean;
  displayedColumns: string[] = ['attribute', 'value'];
  entries: [string, any][];

  constructor(private notificationService: NotificationService, protected sharedService: SharedService) {
  }

  ngOnInit(): void {
    this.loadDetails(this.id)
  }

  loadDetails(id: number) {
    this.loading = true;
    this.service.getEntry(id).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: (entry) => {
        this.entries = this.service.getEntryAsArray(entry);
      },
      error: (error) => {
        this.notificationService.openSnackBar(error);
      }
    });
  }
}
